export const PRIMARY_COLOR = '#34ba9e'

export const THEME_COLORS = [
  { color: PRIMARY_COLOR, name: '翡翠绿', swatch: 'bg-[#34ba9e]' },
  { color: '#1677ff', name: '晴空蓝', swatch: 'bg-[#1677ff]' },
  { color: '#08979c', name: '湖水青', swatch: 'bg-[#08979c]' },
  { color: '#4f46e5', name: '靛青蓝', swatch: 'bg-[#4f46e5]' },
  { color: '#7c3aed', name: '鸢尾紫', swatch: 'bg-[#7c3aed]' },
  { color: '#c02679', name: '玫瑰红', swatch: 'bg-[#c02679]' },
  { color: '#d46b08', name: '琥珀橙', swatch: 'bg-[#d46b08]' },
  { color: '#475569', name: '岩石灰', swatch: 'bg-[#475569]' }
] as const

export function isThemeColor(value: unknown): value is string {
  return THEME_COLORS.some((option) => option.color === value)
}
